import {createViewConfig} from '@sail/engine';
import type {View} from '../view';

export type BackdropProps = View.IntrinsicElement<
  'div',
  {
    onClose?: () => void;
    /**
     * @deprecated Use onClose instead of onPress
     * @ignore
     */
    onPress?: () => void;

    /**
     * @private
     *
     * The opacity of the backdrop.
     */
    opacity?: number;
  }
>;

export const BackdropConfig = createViewConfig({
  props: {} as BackdropProps,
  name: 'Backdrop',
  flattens: true,
});
